// -----------------------------------------------------------------------------
// src/components/dashboard/components/ClientPopups.js
// -----------------------------------------------------------------------------
import React from "react";
import AddEditClientDialog  from "./clienteditdialog";
import ClientNotesDialog    from "./clientnotesdialog";
import ClientCampaignsDialog from "./clientcampaignsdialog";

/**
 * Lightweight router that decides which popup to render.
 * Expects the same props you already pass today.
 */
export default function ClientPopups(props) {
  const { popup } = props;
  if (!popup?.type) return null;

  switch (popup.type) {
    case "add":
    case "edit":
      return <AddEditClientDialog   {...props} />;

    case "notes":
      return <ClientNotesDialog     {...props} />;

    case "campaigns":
      return <ClientCampaignsDialog {...props} />;

    default:
      return null;
  }
}
